<template>
    <h1>La page n'existe pas.</h1>
</template>

<script>
export default {
    data () {
        return {
        };
    }
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/components/page/404.vue